module.exports = __webpack_public_path__ + "img/triste.9ffaa282.png";